import Icon from "@ant-design/icons"
import { ReactComponent as PortugalFlag } from "./portugal.svg"

const PortugalFlagIcon = (props: any) => (
  <Icon component={PortugalFlag} {...props} />
)

export default PortugalFlagIcon
